import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useState } from "react";
import { DeleteModal } from "../../components";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useAuth } from "../../store/useAuth";
import { useTomraMachines } from "../../store/useTomraMachines";

dayjs.extend(relativeTime);

export const TomraMachineTable = () => {
  /** Hooks */
  const { allTomraMachines, deleteTomraMachine } = useTomraMachines();
  const navigate = useNavigate();
  const { user } = useAuth();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Name
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Serial number
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Location
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Status
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Unavailable until
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Revneue (month)
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Date
            </th>
            {user?.user_role === 1 || user?.user_role === 7 ? (
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {allTomraMachines?.map((item) => {
            const currentRevenue =
              item?.droppie_revenue_history?.find((item) => !item?.endDate) ??
              null;
            return (
              <tr
                key={item._id}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all sm:whitespace-nowrap text-xs sm:text-base"
                >
                  {item?.name}
                </td>
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base"
                >
                  {item?.serialNumber}
                </td>
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all text-xs sm:text-base"
                >
                  {/* @ts-ignore */}
                  {item?.location?.cost_place}
                </td>
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="px-2 sm:px-6 py-1 sm:py-4"
                >
                  <span
                    className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${
                      item?.status === "not_available"
                        ? "bg-red-100 text-red-700"
                        : "bg-green-100 text-green-700"
                    }`}
                  >
                    {item?.status === "not_available" ? "Not available" : "Available"}
                  </span>
                </td>
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {item?.status === "not_available" && item?.unavailableUntil
                    ? dayjs(item.unavailableUntil).format("DD MMM YYYY")
                    : "-"}
                </td>
                <td
                  onClick={
                    user?.user_role === 1
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {Intl.NumberFormat("nl-NL", {
                    style: "currency",
                    currency: "EUR",
                  }).format(Number(currentRevenue?.amount || 0))}
                </td>
                <td
                  onClick={
                    user?.user_role === 1 || user?.user_role === 7
                      ? () => navigate(`/edit-tomra-machine/${item?._id}`)
                      : undefined
                  }
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {dayjs(item?.createdAt).fromNow()}
                </td>
                {user?.user_role === 1 || user?.user_role === 7 ? (
                  <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                    <EditIcon
                      onClick={() =>
                        navigate(`/edit-tomra-machine/${item?._id}`)
                      }
                      className="mr-3 sm:mr-7"
                    />
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this Tomra machine?"
                        );
                        if (confirmDelete) {
                          deleteTomraMachine(item._id as string);
                        }
                      }}
                    />
                  </td>
                ) : null}
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
